/* Enhances the existing, variant-linked Embla instance; does not create a second carousel. */
(function () {
  'use strict';
  if (window.ozarke32GalleryLoaded) return;
  window.ozarke32GalleryLoaded = true;

  function attach(root) {
    var carousel = root.ozarke32Carousel;
    if (!carousel || root.dataset.galleryBound) return;
    root.dataset.galleryBound = 'true';
    var events = new AbortController();
    var listenerOptions = { signal: events.signal };
    var openers = Array.from(root.querySelectorAll('.ozarke32-open'));
    var thumbs = Array.from(root.querySelectorAll('.ozarke32-thumbnail'));
    var rail = root.querySelector('.ozarke32-rail');
    var railPrev = root.querySelector('.ozarke32-rail-prev');
    var railNext = root.querySelector('.ozarke32-rail-next');
    var prev = root.querySelector('.prev');
    var next = root.querySelector('.next');
    var dialog = root.querySelector('dialog');
    var stage = root.querySelector('.ozarke32-lightbox-stage');
    var fullImage = root.querySelector('[data-lightbox-image]');
    var modalIndex = -1;
    var fullImages = new Map();
    var zoomButton = root.querySelector('[data-lightbox-zoom]');
    var modalPrev = root.querySelector('[data-lightbox-prev]');
    var modalNext = root.querySelector('[data-lightbox-next]');
    var zoom = 1;
    var fitWidth = 1;
    var fitHeight = 1;
    var previousOverflow;
    var returnFocus;
    var pointers = new Map();
    var pinchDistance = 0;
    var pinchZoom = 1;
    var lastTap = { time: 0, x: 0, y: 0 };
    var lastTouchTime = 0;

    function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }
    function updateRail() {
      if (!rail) return;
      var position = isMobile() ? rail.scrollLeft : rail.scrollTop;
      var length = isMobile() ? rail.scrollWidth - rail.clientWidth : rail.scrollHeight - rail.clientHeight;
      railPrev.hidden = position <= 2;
      railNext.hidden = length - position <= 2;
    }
    function showThumbnail(index) {
      if (!rail || !thumbs[index]) return;
      var thumb = thumbs[index];
      var start = isMobile() ? thumb.offsetLeft : thumb.offsetTop;
      var size = isMobile() ? thumb.offsetWidth : thumb.offsetHeight;
      var position = isMobile() ? rail.scrollLeft : rail.scrollTop;
      var viewport = isMobile() ? rail.clientWidth : rail.clientHeight;
      var destination = start < position ? start : start + size > position + viewport ? start + size - viewport : position;
      if (isMobile()) rail.scrollLeft = destination;
      else rail.scrollTop = destination;
      updateRail();
    }
    function scrollRail(direction) {
      var distance = (isMobile() ? rail.clientWidth : rail.clientHeight) * .75 * direction;
      rail.scrollBy({ left: isMobile() ? distance : 0, top: isMobile() ? 0 : distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function setZoom(value, center) {
      var oldZoom = zoom;
      var point = center || { x: stage.clientWidth / 2, y: stage.clientHeight / 2 };
      var imageX = (stage.scrollLeft + point.x) / oldZoom;
      var imageY = (stage.scrollTop + point.y) / oldZoom;
      zoom = Math.max(1, Math.min(4, value));
      fullImage.style.width = fitWidth * zoom + 'px';
      fullImage.style.height = fitHeight * zoom + 'px';
      stage.scrollLeft = imageX * zoom - point.x;
      stage.scrollTop = imageY * zoom - point.y;
      stage.style.cursor = zoom > 1 ? 'grab' : 'zoom-in';
      zoomButton.textContent = zoom > 1 ? '−' : '+';
      zoomButton.setAttribute('aria-label', zoom > 1 ? 'Zoom out' : 'Zoom in');
    }
    function fitImage() {
      var opener = openers[carousel.selectedScrollSnap()];
      var image = opener.querySelector('img');
      var ratio = Number(image.getAttribute('width')) / Number(image.getAttribute('height'));
      fitWidth = Math.min(stage.clientWidth, stage.clientHeight * ratio);
      fitHeight = fitWidth / ratio;
      setZoom(1);
      stage.scrollLeft = stage.scrollTop = 0;
    }
    function prepareImage(index) {
      if (!openers[index]) return;
      var source = openers[index].dataset.fullImage;
      if (fullImages.has(source)) return fullImages.get(source);
      var image = new Image();
      var entry = { image: image, ready: false };
      fullImages.set(source, entry);
      image.decoding = 'async';
      image.onload = function () {
        function display() {
          entry.ready = true;
          if (root.isConnected && dialog.open && modalIndex >= 0 && openers[modalIndex].dataset.fullImage === source) {
            fullImage.src = source;
          }
        }
        if (image.decode) image.decode().then(display, display);
        else display();
      };
      image.src = source;
      return entry;
    }
    function updateModal(index) {
      if (modalIndex === index) return;
      modalIndex = index;
      var opener = openers[index];
      var image = opener.querySelector('img');
      var thumbnail = thumbs[index] && thumbs[index].querySelector('img');
      var preview = image.complete && image.naturalWidth ? image : thumbnail && thumbnail.complete && thumbnail.naturalWidth ? thumbnail : image;
      var entry = prepareImage(index);
      fullImage.alt = image.alt;
      fullImage.src = entry.ready ? opener.dataset.fullImage : preview.currentSrc || preview.src;
      root.querySelector('[data-lightbox-count]').textContent = (index + 1) + '/' + openers.length;
      modalPrev.disabled = index === 0;
      modalNext.disabled = index === openers.length - 1;
      modalPrev.hidden = modalNext.hidden = openers.length < 2;
      fitImage();
      prepareImage(index + 1);
      prepareImage(index - 1);
      var nearbySources = openers.slice(Math.max(0, index - 2), index + 3).map(function (button) { return button.dataset.fullImage; });
      fullImages.forEach(function (cached, source) {
        if (nearbySources.indexOf(source) === -1) fullImages.delete(source);
      });
    }
    function update() {
      var index = carousel.selectedScrollSnap();
      root.querySelector('[data-gallery-count]').textContent = (index + 1) + '/' + openers.length;
      if (prev) prev.disabled = !carousel.canScrollPrev();
      if (next) next.disabled = !carousel.canScrollNext();
      thumbs.forEach(function (thumb, number) {
        thumb.classList.toggle('active', number === index);
        thumb.setAttribute('aria-current', number === index ? 'true' : 'false');
      });
      showThumbnail(index);
      if (dialog.open) updateModal(index);
    }
    openers.forEach(function (opener, index) {
      opener.addEventListener('click', function () {
        if (!carousel.clickAllowed()) return;
        carousel.scrollTo(index, true);
        returnFocus = opener;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        updateModal(index);
      }, listenerOptions);
    });
    root.addEventListener('keydown', function (event) {
      if (event.target.closest('.ozarke32-lightbox-toolbar') && !dialog.open) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        if (event.key === 'ArrowLeft') carousel.scrollPrev(dialog.open);
        else carousel.scrollNext(dialog.open);
      }
    }, listenerOptions);
    root.querySelector('[data-lightbox-close]').addEventListener('click', function () { dialog.close(); }, listenerOptions);
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = previousOverflow || '';
      modalIndex = -1;
      pointers.clear();
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
    }, listenerOptions);
    modalPrev.addEventListener('click', function () { carousel.scrollPrev(true); }, listenerOptions);
    modalNext.addEventListener('click', function () { carousel.scrollNext(true); }, listenerOptions);
    zoomButton.addEventListener('click', function () { setZoom(zoom > 1 ? 1 : 2); }, listenerOptions);
    stage.addEventListener('dblclick', function (event) {
      if (Date.now() - lastTouchTime < 500) return;
      var rect = stage.getBoundingClientRect();
      setZoom(zoom > 1 ? 1 : 2, { x: event.clientX - rect.left, y: event.clientY - rect.top });
    }, listenerOptions);
    function distance() {
      var points = Array.from(pointers.values());
      return Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
    }
    stage.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      if (event.pointerType === 'touch') lastTouchTime = Date.now();
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY, startX: event.clientX, startY: event.clientY, moved: false });
      stage.setPointerCapture(event.pointerId);
      if (pointers.size === 2) { pinchDistance = distance(); pinchZoom = zoom; }
    }, listenerOptions);
    stage.addEventListener('pointermove', function (event) {
      var point = pointers.get(event.pointerId);
      if (!point) return;
      var dx = event.clientX - point.x;
      var dy = event.clientY - point.y;
      point.x = event.clientX;
      point.y = event.clientY;
      if (Math.hypot(point.x - point.startX, point.y - point.startY) > 8) point.moved = true;
      if (pointers.size === 2 && pinchDistance > 0) {
        var points = Array.from(pointers.values());
        var rect = stage.getBoundingClientRect();
        setZoom(pinchZoom * distance() / pinchDistance, { x: (points[0].x + points[1].x) / 2 - rect.left, y: (points[0].y + points[1].y) / 2 - rect.top });
        points.forEach(function (entry) { entry.moved = true; });
      } else if (zoom > 1) { stage.scrollLeft -= dx; stage.scrollTop -= dy; }
    }, listenerOptions);
    function releasePointer(event) {
      var point = pointers.get(event.pointerId);
      if (event.type === 'pointerup' && event.pointerType === 'touch' && point && !point.moved && pointers.size === 1) {
        var now = Date.now();
        if (now - lastTap.time < 320 && Math.hypot(point.x - lastTap.x, point.y - lastTap.y) < 24) {
          var rect = stage.getBoundingClientRect();
          setZoom(zoom > 1 ? 1 : 2, { x: point.x - rect.left, y: point.y - rect.top });
          lastTap.time = 0;
        } else lastTap = { time: now, x: point.x, y: point.y };
      }
      pointers.delete(event.pointerId);
    }
    stage.addEventListener('pointerup', releasePointer, listenerOptions);
    stage.addEventListener('pointercancel', releasePointer, listenerOptions);
    if (rail) {
      rail.addEventListener('scroll', updateRail, listenerOptions);
      railPrev.addEventListener('click', function () { scrollRail(-1); }, listenerOptions);
      railNext.addEventListener('click', function () { scrollRail(1); }, listenerOptions);
    }
    carousel.on('select', update);
    carousel.on('reInit', update);
    var resize = new ResizeObserver(function () {
      var index = carousel.selectedScrollSnap();
      carousel.reInit({ align: isMobile() ? 'center' : 'start', startIndex: index });
      updateRail();
      if (dialog.open) fitImage();
    });
    resize.observe(root.querySelector('.ozarke32-main'));
    var removal = new MutationObserver(function () {
      if (root.isConnected) return;
      if (dialog.open) dialog.close();
      events.abort();
      resize.disconnect();
      removal.disconnect();
      carousel.destroy();
    });
    removal.observe(document.body, { childList: true, subtree: true });
    update();
  }
  document.addEventListener('ozarke32:ready', function (event) { attach(event.target); });
  document.querySelectorAll('[data-ozarke32-gallery]').forEach(attach);
})();
